import template from 'templates/__notificationBanner.tpl';

export default class NotificationBanner {
    constructor(options = {}) {
        this._ = null;
        this.animationSpeed = 300;
        this.elHeader = document.querySelector('header').firstElementChild;
        this.barWrapper = $('.notification-bar-wrapper');
        this.bar = $('.notification-bar');
        this.notification = $('.notification');
        this.message;
        this.success;
        this.init();
    }

    init() {
        window.addEventListener('DOMContentLoaded', () => {
            this.barWrapper = $('.notification-bar-wrapper');
            this.bar = $('.notification-bar');
            this.notification = $('.notification');
        });
    }

    build() {
        if (!this.__isDomEmpty(this._)) {
            // if filter already has content, don't render
            this.__parseOptionsFromDom();
        } else {
            // otherwise, render filters
            this.__render();
        }

        this.doHide();
    }

    setOptions(options) {
        this.options = options;

        return this;
    }

    openNotification(obj) {
        if (typeof obj.autoClose === 'undefined') {
            console.warn(
                'You did not pass an autoClose property. Try passing in a NotificationBarModel object.',
            );
        }

        if (typeof obj.success === 'undefined') {
            console.error(
                'You did not pass a success property. Try passing in a NotificationBarModel object.',
            );
            return;
        }

        if (typeof obj.message === 'undefined' && typeof obj.messageKey === 'undefined') {
            console.error(
                'You did not pass a message or messageKey property. Try passing in a NotificationBarModel object.',
            );
            return;
        }

        if (typeof obj.messageKey !== 'undefined' && obj.messageKey !== '') {
            obj.message = this.getNotificationBarPageAttributes()[obj.messageKey];
        }

        this.message = obj.message;

        this.setNotificationType(obj.success);
        this.setWrapperHeight();
    }

    setNotificationType(isPositive) {
        if (isPositive) {
            this.bar.removeClass('negative').addClass('positive');
        } else {
            this.bar.removeClass('positive').addClass('negative');
        }
    }

    setWrapperHeight() {
        $(this.barWrapper).addClass('showing');
        $(this.bar).addClass('showing');

        $(this.notification).html(this.message);

        $(this.barWrapper)[0].style.height = $(this.bar)[0].getBoundingClientRect().height + 'px';
        this.doShow();
    }

    doShow() {
        $(this.barWrapper)[0].style.maxHeight =
            $(this.bar)[0].getBoundingClientRect().height + 'px';
        $(this.bar)[0].style.top = this.elHeader.getBoundingClientRect().height + 'px';
        this.doHide();
    }

    doHide() {
        setTimeout(() => {
            this.doCollapse();
        }, 5000);
    }

    doCollapse() {
        $(this.notification).empty();
        $(this.bar)[0].style.top = '-54px';
        $(this.barWrapper)[0].style.maxHeight = '0px';
    }

    __render() {
        let self = this;
        this._.append(
            $(
                template({
                    data: self.options,
                    //selected: self.options[self.selectedInd]
                }),
            ),
        );
    }
}
